<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>Stampe</v-toolbar-title>
    </v-toolbar>
    <v-expansion-panels>
      <report v-for="(item, index) of stampe.filter(x => x.nomeReport && !x.nascondiSuElenco)" :key="index" :report="item"/>
    </v-expansion-panels>
  </v-card>
</template>

<script>
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import configurazioni from '@/services/configurazioniService'
  import Report from './report'

  export default {
    components: {
      Report
    },
    mixins: [verificaLicenza],
    data: () => ({
      stampe: []
    }),
    async mounted() {
      await this.verificaModuliLocali()
      this.stampe = await configurazioni.getConfigurazione('report', 'report')
    }
  }
</script>
